var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightBulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.889,
    height: 14
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".light-bulb_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "light-bulb_svg__a",
    d: "M9.306 8.861H5.584M5.299 8.689a3.408 3.408 0 01-1.53-3.417 3.645 3.645 0 013.226-2.914 3.647 3.647 0 014.172 3.475A3.436 3.436 0 019.589 8.69a.593.593 0 00-.284.487v1.614a1.507 1.507 0 01-1.551 1.458h-.62a1.507 1.507 0 01-1.551-1.458V9.18a.6.6 0 00-.284-.491zM12.408 2.912l.738-.694M2.482 8.75l-.738.694M3.102 2.329l-.738-.69M12.408 8.75l.738.694M13.028 5.833h1.048M.813 5.833h1.048M5.584 10.5h3.642"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h14.889v14H0z",
    fill: "none"
  })));
}
export default SvgLightBulb;


//////////////////
// WEBPACK FOOTER
// ./src/components/Quoters/Aflac/icons/light-bulb.svg
// module id = 7878
// module chunks = 13